import React from "react";
import Translator from "Languages/Utility/Translator";

export default function StatusIsFree(cell) {
  return (
    <div className={cell ? 'StatusIconsDisable' : 'StatusIconsEnable'}>
      {
        cell ? <Translator id="freePeriod" /> : <Translator id="nonFreePeriod" />
      }
    </div>
  );
}
